export default {
  "auth/user-not-found": "Пользователь с таким email не найден",
  "auth/wrong-password": "Неверный пароль",
  "auth/email-already-in-use": "Пользователь с таким email уже зарегестрирован",
  "auth/too-many-requests": "Сделано слишком много запросов",
};
